const stripe = window.Stripe && window.Stripe(process.env.S_PUBLISHABLE_KEY);

export default () => {
  const stripeElement = stripe.elements();

  const cardNumberStyle = {
    // style for number
  }

  const cardExpiryStyle = {
    // style for expiry
  }

  const cardCvcStyle = {
    // style for cvc
  }

  // creates desired element
  const cardNumber = stripeElement.create('cardNumber', { style: cardNumberStyle })
  const cardExpiry = stripeElement.create('cardExpiry', { style: cardExpiryStyle })
  const cardCvc = stripeElement.create('cardCvc', { style: cardCvcStyle })

  return {
    cardArr: [cardNumber, cardExpiry, cardCvc], // to be used by element
    mountCardNumber: ref => cardNumber.mount(ref), // mounts to specified element
    mountCardExpiry: ref => cardExpiry.mount(ref), // mounts to specified element
    mountCardCvc: ref => cardCvc.mount(ref), // mounts to specified element
    generateToken: name => stripe.createToken(cardNumber, { name }),
  }
}
